import { render, staticRenderFns } from "./PlaceWorkersAction.vue?vue&type=template&id=5fc438a4&"
import script from "./PlaceWorkersAction.vue?vue&type=script&lang=js&"
export * from "./PlaceWorkersAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports